import { ChevronRight, Layers } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * In quale blocco e' nata una voce di storico del profilo prestativo.
 *
 * Un Overhead Squat fatto dentro il complex «Muscle Snatch + Overhead Squat»
 * entra nello storico dell'Overhead Squat con il carico del complex: senza
 * questa riga si legge come un Overhead Squat da solo, e le note («sporco
 * perche' ho saltato») parlano di un'altra cosa. Il server manda il nome del
 * blocco (`source_exercise_name`) solo per componenti di complex/EMOM e
 * elementi di superset.
 *
 * Con `onOpen` la riga e' il pulsante verso la seduta (`SessionDetailDialog`):
 * e' la domanda con cui ci si arriva, e un'icona sola dal telefono non si
 * scopre.
 */
export function HistoryEntrySource({ entry, onOpen }) {
	const { t } = useLanguage();
	const name = entry?.source_exercise_name;
	if (!name) return null;

	const content = (
		<>
			<Layers className="w-3.5 h-3.5 shrink-0 text-volt" />
			<span className="min-w-0 break-words">
				{t("historyEntryPartOf")} <span className="text-foreground">{name}</span>
			</span>
		</>
	);

	if (!onOpen) {
		return (
			<p className="mt-1 flex items-start gap-1.5 text-xs text-muted-foreground">
				{content}
			</p>
		);
	}

	return (
		<button
			type="button"
			onClick={onOpen}
			title={t("sessionDetailButton")}
			className="-my-1.5 flex min-h-11 w-full items-center gap-1.5 text-left text-xs text-muted-foreground hover:text-foreground"
		>
			{content}
			<ChevronRight className="w-3.5 h-3.5 shrink-0" />
		</button>
	);
}
